import Home from "../pages/home/home";
import {routeCreator} from "../helpers/routeCreator";
import Login from "../pages/login/login";
import History from "../pages/history/history";
import RequestsForm from "../pages/requestsForm/requestsForm";
import ProfileDetails from "../pages/profile/profileDetails";

//20260603 export const ROUTE_PAGE_LOGIN = routeCreator(Login, '/', 'login', 'Login', 'page.login')
export const ROUTE_PAGE_LOGIN = routeCreator(Login, '/', 'login', 'Login', { exact: true })
export const ROUTE_PAGE_HOME = routeCreator(Home, '/', 'Home', 'page.home', {exact: true})
export const ROUTE_PAGE_CHECKFORM = routeCreator(RequestsForm, '/checkForm', 'checkForm', 'checkForm', {exact: true})
export const ROUTE_PAGE_PROFILE = routeCreator(ProfileDetails, '/profile', 'profileForm', 'profileForm', {exact: true})
export const ROUTE_PAGE_HISTORY = routeCreator(History, '/history', 'history', 'History', {exact: true})

const router = {
    ROUTE_PAGE_HOME,
    ROUTE_PAGE_CHECKFORM,
    ROUTE_PAGE_HISTORY,
    ROUTE_PAGE_PROFILE
}

export default router;